var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24.6",
    style: {
      enableBackground: "new 0 0 24 24.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,12.6c0,3.7-1.3,6.9-3.6,9c-2,1.9-4.8,3-8.1,3c-4.8,0-8.9-2.8-10.9-6.8C0.5,16.1,0,14.3,0,12.3 s0.5-3.8,1.3-5.5c2-4,6.2-6.8,10.9-6.8c3.3,0,6.1,1.2,8.2,3.2l-3.5,3.5c-1.3-1.2-2.9-1.8-4.7-1.8c-3.2,0-5.9,2.2-6.8,5.1 C5.1,10.7,5,11.5,5,12.3c0,0.8,0.1,1.6,0.4,2.3c1,2.9,3.7,5.1,6.8,5.1c1.6,0,3-0.4,4.2-1.2c1.3-0.9,2.2-2.2,2.4-3.7h-6.6v-4.7h11.5 C23.9,10.9,24,11.7,24,12.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon-google.9ad75988c5f16af55099a6b03ee7cc28.svg";
export { ForwardRef as ReactComponent };